/**
 * @ngdoc directive
 * @name WebCoreModule.directive:form
 * @restrict E
 * @element form
 * @description
 * The required directive adds a legend to the form if one doesn't exist. This directive removes the legend if
 * no required fields exist on the page.
 */

angular.module('WebCoreModule')
    .directive('form', function () {
        return {
            restrict: 'E',
            link: function (scope) { // jshint ignore:line
                scope.$on('$viewContentLoaded', angular.bind(this, function () {
                    var required = $('[required]');
                    if(required.length<1) {
                        var legend = $('.required-legend');
                        legend.remove();
                    }
                }));

            }
        };
    });
